import styled from 'styled-components';

const Grow = styled.div`
  flex-grow: 1;
`;

const Container = styled.div`
  display: flex;
`;

export default {
  Grow,
  Container,
};
